import { createReducer } from '@reduxjs/toolkit';
import { getCertificatesPage } from '../actions/certificatesPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getCertificatesPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
